<section id="films" class="section films" aria-labelledby="films-title">
  <div class="container">
    <header class="section-head films__head" appReveal>
      <p class="eyebrow">Video gallery</p>
      <h2 id="films-title" class="title">Watch Little Nap <em>in motion</em></h2>
      <p class="lead">Films from the Little Nap workshop and the rooms our recliners live in.</p>
    </header>

    <button type="button" class="feature" (click)="play(featured, $event)" appReveal="80" [attr.aria-label]="'Play film: ' + featured.title">
      <img class="feature__img" [src]="featured.thumb" alt="" width="1920" height="700" loading="lazy" />
      <span class="feature__tag"><i aria-hidden="true"></i>{{ featured.tag }}</span>
      <span class="play play--lg" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M8 5.5v13l11-6.5z" /></svg>
      </span>
      <span class="feature__copy">
        <span class="feature__title">{{ featured.title }}</span>
        <span class="feature__text">{{ featured.text }}</span>
      </span>
    </button>

    <ul class="clips">
      @for (v of videos; track v.title; let i = $index) {
        <li [appReveal]="i * 80">
          <button type="button" class="clip" (click)="play(v, $event)" [attr.aria-label]="'Play film: ' + v.title">
            <span class="clip__shot">
              <img [src]="v.thumb" alt="" width="560" height="315" loading="lazy" />
              <span class="play" aria-hidden="true">
                <svg viewBox="0 0 24 24"><path d="M8 5.5v13l11-6.5z" /></svg>
              </span>
            </span>
            <span class="clip__body">
              <span class="clip__tag">{{ v.tag }}</span>
              <span class="clip__title">{{ v.title }}</span>
              <span class="clip__text">{{ v.text }}</span>
              <span class="clip__watch">
                Watch film
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" /></svg>
              </span>
            </span>
          </button>
        </li>
      }
    </ul>
  </div>

  @if (playing(); as video) {
    <!-- (the player only exists while a film is playing) -->
    <div class="modal" role="dialog" aria-modal="true" [attr.aria-label]="video.title" (click)="close()" data-clear-fabs>
      <div class="modal__frame" (click)="$event.stopPropagation()">
        <iframe [src]="src()" [title]="video.title" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>
      </div>
      <button #closeButton type="button" class="modal__close" aria-label="Close video" (click)="close()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </div>
  }
</section>
